// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { AccountCryptonym } from './account-cryptonym';
import { AccountImage } from './account-image';
import { ActiveStatus } from './active-status';
import { Addon } from './addon';
import { AddonBin } from './addon-bin';
import { DocSubmitType } from './doc-submit-type';
import { EntityIssue } from './entity-issue';
import { ItemDetail } from './item-detail';
import { JoHeader } from './jo-header';
import { PoDetail } from './po-detail';
import { ActiveStatusEnum } from './enums';
import { DocSubmitTypeEnum } from './enums';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class Account extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Int32 key */
  id!: number;
  /** String(60) */
  accountName!: string;
  /** String(20) */
  accountTaxExemptionNumber?: string;
  /** Enum FK activeStatus */
  activeStatusId!: ActiveStatusEnum;
  /** Boolean */
  allowPartialShipments!: boolean;
  /** Boolean */
  allowReissuanceOrders!: boolean;
  /** Int32 */
  dueDateNumDays?: number;
  /** Boolean */
  excludeFromAnalytics!: boolean;
  /** String(100) */
  gLAccountRef?: string;
  /** Enum FK invoiceDocSubmitType */
  invoiceDocSubmitTypeId!: DocSubmitTypeEnum;
  /** String(254) */
  invoiceEmail?: string;
  /** Boolean */
  isPickupAccount!: boolean;
  /** DateTimeOffset */
  modTs?: Date;
  /** String(6) */
  oLD_ACC_KEY?: string;
  /** Guid */
  proximityAccountId?: string;
  /** Binary */
  rowVersion!: any;
  /** Boolean */
  saveOutputToPdf!: boolean;
  /** DateTime */
  startDate!: Date;
  /** Inv FK accountId */
  accountCryptonym!: AccountCryptonym;
  /** Inv FK accountId */
  accountImages!: AccountImage[];
  /** FK activeStatusId */
  activeStatus!: ActiveStatus;
  /** Inv FK accountId */
  addonBins!: AddonBin[];
  /** Inv FK accountId */
  addons!: Addon[];
  /** Inv FK accountId */
  entityIssues!: EntityIssue[];
  /** FK invoiceDocSubmitTypeId */
  invoiceDocSubmitType!: DocSubmitType;
  /** Inv FK accountId */
  itemDetails!: ItemDetail[];
  /** Inv FK accountId */
  joHeaders!: JoHeader[];
  /** Inv FK accountId */
  poDetails!: PoDetail[];
}

